<header class="TotemHeader text-dark bg-white">
    <div [style.backgroundColor]="configData?.headerBackgroundColor" [style.color]="configData?.headerTextColor">
        <div class="d-flex justify-content-between align-items-center p-3">
            <div class="TotemHeader-Title">
                <button type="button" class="TotemHeader-Title-Logo me-3 btn p-0 border-0 bg-transparent" (click)="showVersions()" [attr.aria-label]="'totem-header.versions-title' | locTranslate">
                    <img [src]="configData?.headerLogo || configData?.logo || 'assets/images/cluer-logo.svg'" [alt]="'totem-a11y.logo' | locTranslate"/>
                </button>
                <div class="TotemHeader-Title-Text ps-3 mb-0 border-start" [innerHTML]="totemTitleFormatted"></div>
            </div>
            <div class="d-flex align-items-center TotemHeader-Controls">
                <ng-content></ng-content>
                <div class="TotemHeader-Controls-Select TotemHeader-Controls-Select--Language d-flex align-items-center ms-3" role="group" [attr.aria-label]="'totem-a11y.language' | locTranslate">
                    <div class="TotemHeader-Controls-Select-Icon" aria-hidden="true">
                        <i class="fa-regular fa-thin fa-globe opacity-70"></i>
                    </div>
                    <div class="TotemHeader-Controls-Select-Input ms-2">
                        <app-pg-select [required]="true" [options]="languageOptions" [ngModel]="currentLanguage" (ngModelChange)="setLanguage($event)" display="oneLine" [forcedPlacement]="'right-bottom'" [ariaLabel]="'totem-a11y.language' | locTranslate"></app-pg-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="TotemHeader-TitleSub py-2 px-3">
            <div class="TotemHeader-TitleSub-Text mb-0 text-center" [innerHTML]="configData?.title | locTranslate"></div>
        </div>
    </div>
</header>
